import { Pipe, PipeTransform } from '@angular/core';
import { SLMovementLineNature } from './movement';

@Pipe({ name: 'slmovementlinenature' })
export class SLMovementLineNaturePipe implements PipeTransform {
 
  transform(value: SLMovementLineNature, ...args: any[]) {
    if (value === 'TRANSFER') {
      return 'Transfert';
    }
    else if(value === 'SUBSCRIPTION') {
      return 'Souscription';
    }
    else if(value === 'CANCELLATION') {
      return 'Annulation';
    }
    else if(value === 'OTHER') {
      return 'Autre';
    }
    else {
      return value;
    }
  }
}
